import { createSlice } from '@reduxjs/toolkit';

import { ASYNC_STATUS, type AsyncStatus } from '@/packages/typesafe-result';

import { type IHighwayDirection } from '@/microfrontends/filters/shared/types/highways';

import { requestHighways } from '../../thunks/highways';

export type THighwaysState = {
  [regionId: number]:
    | {
        data: IHighwayDirection[];
        status: AsyncStatus;
      }
    | undefined;
};

const highwaysInitialState: THighwaysState = {};

export const highwaysSlice = createSlice({
  initialState: highwaysInitialState,
  name: 'highways',
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(requestHighways.pending, (state, action) => {
        state[action.meta.arg] = {
          data: [],
          status: ASYNC_STATUS.PENDING,
        };
      })
      .addCase(requestHighways.fulfilled, (state, action) => {
        state[action.meta.arg] = {
          data: action.payload,
          status: ASYNC_STATUS.SUCCESS,
        };
      })
      .addCase(requestHighways.rejected, (state, action) => {
        state[action.meta.arg] = {
          data: [],
          status: ASYNC_STATUS.ERROR,
        };
      });
  },
});

export const { reducer: highwaysReducer, actions: highwaysActions } = highwaysSlice;
